export const RECIPESTS_DATA_REQUEST = "RECIPESTS_DATA_REQUEST"
export const REPORT_DATA_REQUEST = "REPORT_DATA_REQUEST"
export const UPDATE_PAGINATION_COUPON_LIST = "UPDATE_PAGINATION_COUPON_LIST"
export const DASHBOARD_LOADING = "DASHBOARD_LOADING"
export const DASHBOARD_DATA = "DASHBOARD_DATA"
export const DASHBOARD_CAMPAIGN = "DASHBOARD_CAMPAIGN"
export const DASHBOARD_DETAIL_LOADING = "DASHBOARD_DETAIL_LOADING"